import * as React from "react";
import {none, Option, option, some} from "ts-option";
import IndividualContact from "../../../../model/contact/IndividualContact";
import CreateContactModal from "../../modal/CreateContactModal";
import * as validator from "validator";
import ContactSelector from "../../select/ContactSelector";
import {FocusableProps} from "../../../common/props/FocusableProps";
import {PressableProps} from "../../../common/props/PresableProps";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface State {
	/**
	 * Indicates if modal contact creator is open.
	 */
	contactCreation: boolean;
	/**
	 * String to use as initial data for the form.
	 */
	prePopulatedString?: Option<string>;
}

type Props = FormGroupProps<string> & FocusableProps & PressableProps;

/**
 * Contact form view group.
 */
export default class ContactFormGroup extends React.PureComponent <Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {contactCreation: false, prePopulatedString: none};
		this.contactAdded = this.contactAdded.bind(this);
		this.contactSelected = this.contactSelected.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openModal = this.openModal.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<span style={{float: "right"}}>
					<span className={"t-link"} onClick={this.openModal}>create new</span>
				</span>
				<ContactSelector selectedId={this.props.field.value}
								 placeholder={"Contact"}
								 onInputChange={(data) => this.setState(
									  {prePopulatedString: option(validator.isEmpty(data) ? null : data)})}
								 contactId={this.props.field.value}
								 focus={this.props.form && this.props.form.hasFocus(this.props.field)}
								 onFocus={() => {
									  this.props.onFocus && this.props.onFocus();
									  this.props.onFocusChange && this.props.onFocusChange(this.props.field);
								  }}
								 onEnter={this.props.onEnter}
								 onChanged={this.contactSelected}/>
				{this.renderModal()}
			</FormGroup>

		);
	}

	/**
	 * Render modal.
	 */
	renderModal() {
		if (this.state.contactCreation)
			return <CreateContactModal onClose={this.closeModal}
									   onSuccessIndividual={this.contactAdded}
									   prePopulatedString={this.state.prePopulatedString}/>
	}

	/**
	 * Callback on selected contact.
	 * @param optionalContact selected contact.
	 */
	contactSelected(optionalContact: Option<IndividualContact>) {
		optionalContact.map(contact => {
			this.props.onChange(this.props.field.updateValue(some(contact.id)));
		}).getOrElse(() => {
			this.props.onChange(this.props.field.updateValue(none));
			return null;
		});
	}

	/**
	 * On contact added action.
	 * @param {IndividualContact} contact Currently added contact.
	 */
	contactAdded(contact: IndividualContact) {
		this.props.onChange(this.props.field.updateValue(some(contact.id)));
		this.closeModal();
	}

	/**
	 * Close modal with contact creator.
	 */
	closeModal() {
		this.setState({contactCreation: false});
	}

	/**
	 * Open modal with contact creator.
	 */
	openModal() {
		this.setState({contactCreation: true});
	}

}